import * as React from 'react';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { AppBar, Button, IconButton, Stack, Toolbar } from '@mui/material';
import { SnackbarProvider } from "notistack";

import MenuIcon from '@mui/icons-material/Menu';
import AddExpenses from './pages/add_expenses/AddExpenses';
import NavDrawer from './components/nav_drawer/NavDrawer';
import { validateAppKey } from './helpers/crypto';
import EnterPassword from './pages/enter_password/EnterPassword';

export enum Tab {
  AddExpense,
}

export default function App() {
  const [currentTab, setCurrentTab] = React.useState<Tab>(Tab.AddExpense);
  const [navDrawerOpen, setNavDrawerOpen] = React.useState<boolean>(false);

  const keyCookie = document.cookie.split(";").find((cookie) => cookie.includes("vegas-expenses-key"));
  const keyCookieValue = keyCookie ? keyCookie.split("=")[1] : undefined;
  const authPassed = keyCookieValue ? validateAppKey(keyCookieValue) : false;

  function renderCurrentTab() {
    if (!authPassed) {
      return <EnterPassword />
    }

    switch (currentTab) {
      case Tab.AddExpense:
        return <AddExpenses />;
    }
  }

  return (
    <SnackbarProvider maxSnack={3} autoHideDuration={2500}>
      <Stack alignItems="center" sx={{ width: "100vw", height: "100vh" }}>
        <Box sx={{ maxWidth: "600px", width: "100%", height: "100%" }}>
          <AppBar position="static">
            <Toolbar>
              <IconButton
                size="large"
                edge="start"
                color="inherit"
                sx={{ mr: 2 }}
                disabled={!authPassed}
                onClick={() => setNavDrawerOpen(true)}
              >
                <MenuIcon
                  htmlColor={authPassed ? "inherit" : "rgba(255, 255, 255, 0.5)"}
                />
              </IconButton>
              <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                Vegas Expenses
              </Typography>
            </Toolbar>
          </AppBar>
          <Stack width="100%" alignItems="center">
            <Container sx={{ height: "calc(100vh - 56px)", pt: 2, pb: 2 }}>
              {renderCurrentTab()}
            </Container>
          </Stack>
        </Box>
        <NavDrawer
          open={navDrawerOpen}
          onClose={() => setNavDrawerOpen(false)}
          onTabSelected={(tab) => {
            setCurrentTab(tab);
            setNavDrawerOpen(false);
          }}
        />
      </Stack>
    </SnackbarProvider>
  );
}
